import * as React from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';
const Summary = ({ className, children }) => {
    const theme = useTheme('PaymentForm').Summary;
    return React.createElement("div", { className: cn(className, theme.container) }, children);
};
export default Summary;
